<app-breadcrumb [title]="'Cart'" class="hidevalue" [breadcrumb]="'Cart'"></app-breadcrumb>
<!-- <app-breadcrumb [title]="'Cart'"  [breadcrumb]="'Cart'"></app-breadcrumb> -->

<!-- section start -->

<div *ngIf="lenData.length == 0 && hidval == false" id="cartloader">
    <!-- <div style="height: 743px;"> -->
    <div class="preloader">
        <div class="loader">
            <div class="loaderzig">
                <div class="loader__part loader__part--1"></div>
                <div class="loader__part loader__part--2"></div>
                <div class="loader__part loader__part--3"></div>
            </div>
        </div>
    </div>
    <!-- </div> -->
</div>


<section class="cart-section section-b-space pad0" id="cartinformation">
    <div class="container">
        <div class="col-sm-12 empty-cart-cls text-center" *ngIf="!lenData?.length && hidval == true">
            <img src="assets/images/icon-empty-cart.png" class="img-fluid mb-4">
            <h3><strong>Your Cart is Empty</strong></h3>
            <h4>Add something to make me happy :)</h4>
        </div>
        <div class="col-12 text-center py-md-4 pt-4" *ngIf="!lenData?.length && hidval == true">
            <a [routerLink]="['/shop/collection/left/sidebar']" [queryParams]="{ category: someCondition }"
                class="btn btn-solid">continue shopping</a>
        </div>

        <div class="row" *ngIf="lenData?.length">
            <div class="col-sm-12 hidevalue">
                <table class="table cart-table table-responsive-xs">
                    <thead>
                        <tr class="table-head">
                            <th scope="col">image</th>
                            <th scope="col">product name</th>
                            <th scope="col">price</th>
                            <th scope="col">quantity</th>
                            <th scope="col">total</th>
                            <th scope="col">action</th>
                        </tr>
                    </thead>


                    <tbody *ngFor="let item of Livecart">
                        <tr>
                            <td>

                                <div class="front hidevalue position-relative">
                                    <div class="row">
                                        <a *ngIf="item.products?.Name"
                                            (click)="edit(item.products?.Id, item.cartid, item.products?.Name, item.weight?.TypeId)">
                                            <img [defaultImage]="item.products?.ImgUrl || 'assets/images/product/placeholder.jpg'"
                                                [lazyLoad]="item.products?.ImgUrl || 'assets/images/product/placeholder.jpg'"
                                                class="img-fluid lazy-loading" alt="{{ item.products?.ImgUrl }}" />
                                        </a>
                                        <a href="javascript:void(0)" title="Add to Wishlist" (click)="addToWishlist(item)" class="wishlist-icon">
                                            <i class="fa fa-heart" aria-hidden="true" style="float: inline-end;"
                                                [style.color]="item.fav ? 'red' : 'grey'"></i>
                                        </a>
                                    </div>
                                </div>
                                


                                <div class="front mobile-cart-content">
                                    <a *ngIf="item.products.Name"
                                        (click)="edit(item.products.Id,item.cartid,item.products.Name,item.weight.TypeId)">
                                        <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'"
                                            [lazyLoad]="ImageSrc ? ImageSrc : item.products.ImgUrl"
                                            class="img-fluid lazy-loading" alt="{{ item.products.ImgUrl }}" />


                                    </a>
                                </div>
                            </td>

                            <td>

                                <h4 class="h4text">
                                    {{item.products.Name | titlecase }} <span *ngIf="item.weight.QtyText.length > 0">-
                                        {{item.weight.QtyText }}</span>
                                </h4>

                                <div *ngFor="let addns of item.addons">
                                    <h6 class="h6text"> {{addns.qtyText }}
                                    </h6>
                                </div>
                                <h6 class="h6text">
                                    <span>{{item.variants?.qtyText }}</span>
                                </h6>

                                <!-- <h6 style="text-align: justify;"> {{item.variants?.qtyText }} </h6> -->


                                <h6 class="text-light-emphasis bdmsg " *ngIf="item.Msg">

                                    "{{item?.Msg}}"

                                </h6>
                            </td>

                            <td>

                                <h2>
                                    <!-- {{ item.weight.Price }} {{item.variants?.price}} ----
                                    {{item.weight.Qty}} ---{{item.addons.TPrice }} -->

                                    &#8377; {{ (item.weight.Price + (item.variants?.price || 0) + ( item.addons?.TPrice
                                    || 0) ) }}
                                </h2>
                            </td>



                            <td>
                                <div class="qty-box">
                                    <div class="input-group">
                                        <span class="input-group-prepend">
                                            <button type="button" class="btn quantity-left-minus" data-type="minus"
                                                id="minus-btn" aria-label="minus Data" (click)="decrement(item)">
                                                <i class="ti-angle-left"></i>
                                            </button>
                                        </span>
                                        <input type="text" name="quantity" class="form-control input-number" disabled
                                            [(ngModel)]="item.Quantity_No">
                                        <span class="input-group-prepend">
                                            <button type="button" class="btn quantity-right-plus" data-type="plus"
                                                id="plus-btn" aria-label="plus Data" (click)="increment(item)">
                                                <i class="ti-angle-right"></i>
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </td>




                            <td>
                                <h2 class="td-color">

                                    <!-- {{item.addons.TPrice}}----{{item.variants?.price}} ----{{item.weight?.Price}} {{item.Quantity_No }} -->
                                    &#8377; {{ (( (item.addons.TPrice || 0) + (item.variants?.price || 0) +
                                    (item.weight?.Price || 0))
                                    * (item.Quantity_No || 1)) | number:'.2' }}
                                </h2>

                            </td>

                            <td>
                                <a href="javascript:void(0)" (click)="removeItem(item.cartid)" class="icon"
                                    Tooltip="Remove Item">
                                    <i style="font-size: 20px;color: red;" class="fa fa-trash" aria-hidden="true"></i>
                                </a>

                            </td>


                        </tr>
                    </tbody>


                </table>
                <table class="table cart-table table-responsive-md">
                    <tfoot>
                        <tr>
                            <td>total price :</td>
                            <td>
                                <h2 *ngIf="TotalAMount"> &#8377;{{ TotalAMount |
                                    number:".2"}}</h2>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class=" col-sm-12 mobilehide">


                <div class="card" *ngFor="let item of Livecart"
                    style="width:95%;  margin-left: 10px;    margin-top: 10px;">
                    <div class="card-body" style="    padding: 10px;">
                        <div class="row">
                            <div class="col-6">

                                <div class="front mobile-cart-content">
                                    <a *ngIf="item.products.Name"
                                        (click)="edit(item.products.Id,item.cartid,item.products.Name,item.weight.TypeId)">
                                        <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'"
                                            [lazyLoad]="ImageSrc ? ImageSrc : item.products.ImgUrl"
                                            class="img-fluid lazy-loading" style="width: 112px;
                                        height: auto;" alt="{{ item.products.ImgUrl }}" />


                                    </a>
                                </div>


                            </div>
                            <div class="col-6">
                                <h4 class="h4mobview">
                                    {{item.products.Name | titlecase }} <span *ngIf="item.weight.QtyText.length > 0">-
                                        {{item.weight.QtyText }}</span>
                                </h4>

                                <div *ngFor="let addns of item.addons">
                                    <h6 class="h6text"> {{addns.qtyText }}
                                    </h6>
                                </div>
                                <h6 class="h6text">
                                    <span>{{item.variants?.qtyText }}</span>
                                </h6>

                                <h6 class="text-light-emphasis bdmsg" *ngIf="item.Msg">

                                    "{{item?.Msg}}"

                                </h6>

                                <h2 style="color: black;    font-size: 20px;">
                                    &#8377;{{ item.SubTotal }}
                                </h2>


                            </div>
                            <div class="col-6">
                                <div class="qty-box">
                                    <div class="input-group" style="justify-content: flex-start;    margin-top: 10px;">
                                        <span class="input-group-prepend" style="height: 30px;">
                                            <button type="button" class="btn quantity-left-minus" data-type="minus"
                                                id="minus-btn" aria-label="minus Data" (click)="decrement(item)">
                                                -
                                            </button>
                                        </span>
                                        <input type="text" name="quantity" class="form-control input-number"
                                            style="height: 30px; width: 50px;" disabled [(ngModel)]="item.Quantity_No">
                                        <span class="input-group-prepend">
                                            <button type="button" class="btn quantity-right-plus" style="height: 30px;"
                                                id="plus-btn" aria-label="plus Data" data-type="plus"
                                                (click)="increment(item)">
                                                +
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="row">
                                    <div class="col" style="margin-top:8px;  ">
                                        <button *ngIf="item.weight.TypeId != 4" id="edit-btn" aria-label="edit Data"
                                            (click)="edit(item.products.Id,item.cartid,item.products.Name,item.weight.TypeId)"
                                            class="btn btn-theme edtbtn">Edit</button>

                                        <button (click)="removeItem(item.cartid)" id="delete" aria-label="delete Data"
                                            class="btn btn-theme deletebtn">Delete</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                </div>

                <div style="margin-top: 20px;">

                    <h2 *ngIf="TotalAMount" style="float: inline-end;    margin-right: 10px;"> <span style="    font-size: 15px;
                    padding-right: 10px;
                    text-transform: capitalize;    

                    font-weight: 700;">Subtotal :</span> &#8377;{{ TotalAMount |
                        number:".2"}}</h2>
                </div>
            </div>
        </div>

        <div class="row cart-buttons" *ngIf='lenData?.length'>
            <div class="col-7">
                <a [routerLink]="['/shop/collection/left/sidebar']" [queryParams]="{ category: someCondition }"
                    class="btn btn-solid">continue shopping</a>
            </div>

            <div class="col-5">
                <button (click)="CheckOut()" id="checkout-btn" aria-label="checkout Data" class="btn btn-solid">Check
                    Out</button>
            </div>

        </div>

        <div class="row cart-buttons mobilehide" style="padding-bottom: 100px;" *ngIf='lenData?.length'>
            <div class="col-12">
                <!-- <button id="checkout-btn" aria-label="checkout Data" (click)="CheckOut()"
                    class="btn btn-solid checkoutbtn" *ngIf="totalQty">CheckOut ({{totalQty}}
                    <span>Items</span> )</button> -->
            </div>

        </div>

    </div>
</section>
<!--section end-->


<!-- POPUP -->


<ng-template #loginModel let-modal>
    <div class="modal-body" id="loginmodel">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="modal-body">
                    <strong>
                        <h5>You are Not Logged In, Please Login to proceed to checkout!..</h5>
                    </strong>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-solid" data-dismiss="modal" id="close-btn"
                        aria-label="close Data" (click)="modal.dismiss('Cross click')">Close</button>
                    <button type="button" class="btn btn-solid" (click)="logincheck()" id="login"
                        aria-label="login Data">Login</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<div style="display: none;" id="preloadercrt">
    <!-- <img  alt=""> -->
    <div id="loadercrt">
        <div class="loaderzig">
            <div class="loader__part loader__part--1"></div>
            <div class="loader__part loader__part--2"></div>
            <div class="loader__part loader__part--3"></div>
        </div>
    </div>
</div>

<div class="mobileimg">
    <h1 style="color: white;"></h1>
</div>